module.exports = __webpack_public_path__ + "img/ayun-sticker-printer.24140c40.svg";